class SectionTestimonialCarousel extends HTMLElement {
  constructor() {
    super();
    this.data = scrapeSectionData(this);
    this.carousel = this.querySelector("[data-testimonial-carousel]");

    window.loadSwiper.then((swiperLib) => {
      this.swiperLib = swiperLib;
      this.initFunction();
    });

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:load', (event) => {
        window.loadSwiper.then((swiperLib) => {
          this.swiperLib = swiperLib;
          this.init();
        });
      });
    }
  }


  initFunction() {
    const { Swiper, Pagination, EffectFade } = this.swiperLib;

    const params = {
      modules: [Pagination, EffectFade],
      // Default parameters
      slidesPerView: 1,
      spaceBetween: 0,
      direction: "horizontal",
      loop: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: ".swiper-arrow.next",
        prevEl: ".swiper-arrow.prev",
      },
      watchOverflow: true
    };

    if (!this.carousel) return;

    let swiper = new Swiper(this.carousel, params);

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:load', (event) => {
        swiper.destroy();
      });
    }
  }
}

if (!customElements.get("section-testimonial-carousel")) {
  customElements.define(
    "section-testimonial-carousel",
    SectionTestimonialCarousel
  );
}
